<div *ngIf="type == 'Login' && loggedIn;">
  <div class="modal">
    <div class="modal-header confirm">
      <i class="bi bi-check-circle-fill"></i>
    </div>
    <div class="modal-body">
      <h2>Bevestig aanmelding</h2>
      <p>Door je aan te melden, ga je ermee akkoord dat jouw naam en e-mailadres met de organisator van deze activiteit worden gedeeld.</p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-back" (click)="close()">Terug</button>
      <button class="btn btn-agree confirm" (click)="signUp()">Aanmelden</button>
    </div>
  </div>
</div>
<div *ngIf="type == 'Login' && !loggedIn;">
  <div class="modal">
    <div class="modal-header login">
      <i class="bi bi-box-arrow-in-right"></i>
    </div>
    <div class="modal-body">
      <h2>Account vereist</h2>
      <p>Om je aan te melden voor een activiteit moet je ingelogd zijn! </p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-back" (click)="close()">Terug</button>
      <button class="btn btn-agree login" (click)="redirectToLogin()">Inloggen</button>
    </div>
  </div>
</div>
<div *ngIf="type == 'Delete' && loggedIn;">
  <div class="modal">
    <div class="modal-header delete">
      <i class="bi bi-trash-fill"></i>
    </div>
    <div class="modal-body">
      <h2>Weet je het zeker?</h2>
      <p>Deze actie zal de activiteit permanent verwijderen, deze actie kan niet ongedaan worden gemaakt.</p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-back" (click)="close()">Terug</button>
      <button class="btn btn-agree delete" (click)="deleteActivity()">Verwijderen</button>
    </div>
  </div>
</div>
